let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dA1E5"), load("joJy8"), load("aHE9G"), load("cPaXL")]).then(() => parcelRequire('v2hhG'));